<ng-template #content let-modal>
  <div class="modal-header">
    <div class="col-md-12">
      @if (step === 'openItemDetail') {
        <span class="modal-title">{{
          modalTitle
        }}</span>
      }
      @if (step === 'discardItem') {
        <span class="modal-title">{{
          app.text.modal.modalTitle
        }}</span>
      }
      <button class="btn pull-right" (click)="cleanData(); discardChanges()">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    @if (type === 'discard') {
      <div>
        @if (step === 'discardItem') {
          <span>
            {{ app.text.modal.discard }}
          </span>
        }
        @if (showItemFields && step === 'openItemDetail') {
          <div>
            @for (field of fields; track field; let index = $index) {
              <app-field
                [model]="modelDoc"
                [field]="field"
                [index]="index"
              ></app-field>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (showButtons) {
    <div class="modal-footer pt-0">
      <button
        class="btn btn-ok text-center m-1"
        (click)="modal.close('OK'); app.pcnGenerator.createItem(modelDoc)"
      [disabled]="
        app.pcnGenerator.hasInvalidFieldsByBox(app.leftNav.selectedBox)
      "
        type="submit"
        >
        {{ app.text.app.save }}
      </button>
      <!-- <button
      class="btn btn-ok text-center m-1 mx-5"
      (click)="modal.close('OK'); app.pcnGenerator.createItem(modelDoc)"
      *ngIf="step === 'openItemDetail'"
      [disabled]="
        app.pcnGenerator.hasInvalidFieldsByBox(app.leftNav.selectedBox)
      "
      >
      {{ app.text.modal.ok }}
    </button>
    <button
      class="btn btn-ok text-center m-1"
      (click)="goToNext(step, 'save')"
      *ngIf="step === 'discardItem'"
      >
      {{ app.text.modal.ok }}
    </button>
    <button
      class="btn btn-cancel text-center m-1"
      (click)="goToNext(step, 'dismiss')"
      >
      {{ app.text.modal.cancel }}
    </button> -->
  </div>
}
</ng-template>
